import React, { useState, useEffect } from "react";
import { Platform, AppState } from "react-native";
import { check, request, PERMISSIONS, RESULTS } from "react-native-permissions";
import { useDispatch, useSelector } from "react-redux";
import analytics from "@services/analytics";
import { LOCATION_EVENTS } from "@constants/analyticsEventsCT";
import { actions as miscActions } from "@reducers/miscReducer";
import { useNavigation } from "@react-navigation/native";
import { DrawerActions } from "@react-navigation/native";

const withLocation = (WrappedComponent, payload = {}) => {
  return (props) => {
    const [appState, setAppState] = useState(AppState.currentState);

    useEffect(() => {
      const subscription = AppState.addEventListener(
        "change",
        handleAppStateChange,
      );
      return () => {
        subscription.remove();
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleAppStateChange = async (nextAppState) => {
      // eslint-disable-next-line eqeqeq
      if (appState != nextAppState) {
        setAppState(nextAppState);
      } else {
        const status = await check(PERMISSIONS.ANDROID.ACCESS_FINE_LOCATION);
        if (status === RESULTS.GRANTED) dispatch(miscActions.hideSettingsModal());
      }
    };

    const dispatch = useDispatch();
    const navigation = useNavigation();
    const { currentRouteName = "" } = useSelector((state) => state.navigation);

    const handleNavigation = (navPayload) => {
      navigation.dispatch(DrawerActions.closeDrawer());

      if (currentRouteName === "NotServicable") {
        navigation.navigate("HomeStack", {
          screen: "LocationViaAddress",
          params: {
            ...navPayload,
          },
        });
        return;
      }
      if (currentRouteName === "AskLocation") {
        navigation.navigate("Location", { ...navPayload });
        return;
      }
      navigation.push("LocationViaAddress", { ...navPayload });
    };

    const getLocationAndNavigate = async () => {
      if (
        currentRouteName === "NotServicable" ||
        currentRouteName === "AskLocation"
      ) {
        if (Platform.OS === "android") {
          const current = await check(PERMISSIONS.ANDROID.ACCESS_FINE_LOCATION);
          if (current === RESULTS.GRANTED) {
            dispatch(miscActions.setAskLocationInside(true));
            dispatch(miscActions.setShowLocationSearch(false));
            handleNavigation(payload);
          } else {
            const result = await request(PERMISSIONS.ANDROID.ACCESS_FINE_LOCATION);
            if (result === RESULTS.GRANTED) {
              analytics.trackEvent(LOCATION_EVENTS.PERMISSION_GRANTED);
              dispatch(miscActions.setShowLocationSearch(false));
              dispatch(miscActions.setAskLocationInside(true));
              handleNavigation(payload);
            } else if (result === RESULTS.BLOCKED) {
              dispatch(miscActions.setShowLocationSearch(true));
              dispatch(miscActions.setAskLocationInside(false));
              analytics.trackEvent(LOCATION_EVENTS.PERMISSION_DENIED);
              handleNavigation(payload);
              dispatch(miscActions.showSettingsModal());
            } else {
              dispatch(miscActions.setShowLocationSearch(true));
              dispatch(miscActions.setAskLocationInside(false));
              analytics.trackEvent(LOCATION_EVENTS.PERMISSION_DENIED);
              handleNavigation(payload);
            }
          }
        }
      } else {
        dispatch(miscActions.setShowLocationSearch(false));
        dispatch(miscActions.setAskLocationInside(true));
        handleNavigation(payload);
      }
    };
    return (
      <WrappedComponent
        {...props}
        getLocationAndNavigate={getLocationAndNavigate}
      />
    );
  };
};
export default withLocation;
